/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import {
  IconButton,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { Delete, Edit, Cancel, Check } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CRUDBoTieuChi from "./formBoTieuChi";
import { darken } from "@mui/material";
import { convertToTitleCase, MenuProps } from "../../../utils/constants";
import { API_ROUTES } from "../../../utils/constants";
const ALLVALUE = { ma: "0", ten: "Tất cả" };

import { useMaterialUIController, setHomePage } from "context";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";

function BoTieuChi() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [nhomcha, setNhomCha] = useState({
    id: "0",
    ten: "Tất cả ",
  });
  const [nhom, setNhom] = useState({
    id: "0",
    ten: "Tất cả ",
  });
  const [nhomSanPham, setNhomSanPham] = useState({
    id: "0",
    ten: "Tất cả ",
  });
  const [optionNhomCha, setOptionNhomCha] = useState();
  const [optionNhom, setOptionNhom] = useState();
  const [optionNhomSanPham, setOptionNhomSanPham] = useState();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const setAlert = useSetRecoilState(AlertState);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [optionBoWithNhom, setOptionBoWithNhom] = useState([]);

  useEffect(() => {
    const fetchDataBoTieuChiWithNhom = async () => {
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.NHOMBOTIEUCHI,
          {
            params: { nhom: 0 },
          }
        );
        const list = response?.data?.data;
        if (list && list?.length > 0) {
          setOptionBoWithNhom(list);
        }
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataBoTieuChiWithNhom();
  }, []);

  const handleDelete = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "botieuchi/" + selectedRow.id
      );
      fetchData(nhomcha, nhom, nhomSanPham, pagination);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "botieuchi/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "botieuchi",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      fetchData(nhomcha, nhom, nhomSanPham, pagination);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const fetchData = async (
    nhomcha,
    nhombotieuchi,
    nhomsanpham,
    { pageIndex, pageSize }
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        nhomcha: nhomcha?.id === ALLVALUE.ma ? undefined : nhomcha?.id,
        nhombotieuchi:
          nhombotieuchi?.id === ALLVALUE.ma ? undefined : nhombotieuchi?.id,
        nhomsanpham:
          nhomsanpham?.id == ALLVALUE.ma ? undefined : nhomsanpham?.id,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.BOTIEUCHI, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(nhomcha, nhom, nhomSanPham, pagination);
  }, [nhomcha, nhom, nhomSanPham, pagination]);

  const fetchDataNhom = async (nhomcha) => {
    try {
      const response = await axiosPrivateInstance.get(
        "nhombotieuchi?nhom=" + nhomcha
      );
      let list = [{ id: "0", ten: "Tất cả" }, ...response.data["data"]];
      setOptionNhom(list);
    } catch (error) {
      setIsError(true);
      return;
    }
  };

  useEffect(() => {
    const fetchDataNhomCha = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomchabotieuchi");
        let list = [{ id: "0", ten: "TẤT CẢ" }, ...response.data];
        setOptionNhomCha(list);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    const fetchDataSanpham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        let list = [{ id: "0", ten: "Tất cả" }, ...response.data["data"]];
        setOptionNhomSanPham(list);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    fetchDataNhomCha();
    fetchDataNhom(0);
    fetchDataSanpham();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "nhombotieuchi_ten",
        header: "Tên nhóm",
      },
      // {
      //   accessorKey: "ma",
      //   header: "Mã bộ tiêu chí",
      // },
      {
        accessorKey: "ten",
        header: "Tên bộ tiêu chí",
      },
      {
        accessorKey: "diem",
        header: "Thang điểm",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return typeof value == "number"
            ? parseFloat(value).toLocaleString("en-US")
            : value;
        },
        muiTableBodyCellProps: {
          align: "right",
        },
      },
    ],
    []
  );

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("botieuchi/" + id);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa bộ tiêu chí");
    setValidationErrors({});
    setModalOpen(true);
  };
  const handleChangeNhomCha = (e, newValue) => {
    setNhomCha(newValue);
    setNhom({
      id: "0",
      ten: "Tất cả ",
    });
    if (newValue?.id) {
      fetchDataNhom(newValue?.id);
    }
  };
  const handleChangeNhom = (e, newValue) => {
    setNhom(newValue);
  };
  const handleChangeNhomSanPham = (e, newValue) => {
    setNhomSanPham(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={4} lg={4}>
            <Autocomplete
              disablePortal
              id="combo-box-nhomcha"
              options={optionNhomCha?.length > 0 ? optionNhomCha : []}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Nhóm cha" />
              )}
              size="medium"
              onChange={handleChangeNhomCha}
              value={nhomcha}
              defaultValue={ALLVALUE.ma}
              getOptionLabel={(option) =>
                optionNhomCha && optionNhomCha?.length > 0
                  ? convertToTitleCase(option.ten)
                  : "Tất cả"
              }
              placeholder="Chọn Nhóm cha"
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {convertToTitleCase(options.ten)}
                </Box>
              )}
              freeSolo
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <Autocomplete
              disablePortal
              id="combo-box-botieuchi"
              options={optionNhom?.length > 0 ? optionNhom : []}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Nhóm bộ tiêu chí" />
              )}
              size="medium"
              onChange={handleChangeNhom}
              value={nhom}
              defaultValue={ALLVALUE.ma}
              getOptionLabel={(option) =>
                optionNhom && optionNhom?.length > 0 ? option.ten : "Tất cả"
              }
              placeholder="Chọn Nhóm bộ tiêu chí"
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {options.ten}
                </Box>
              )}
              freeSolo
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <Autocomplete
              disablePortal
              id="combo-box-nhomsanpham"
              options={optionNhomSanPham?.length > 0 ? optionNhomSanPham : []}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Nhóm sản phẩm" />
              )}
              size="medium"
              onChange={handleChangeNhomSanPham}
              value={nhomSanPham}
              defaultValue={ALLVALUE.ma}
              getOptionLabel={(option) =>
                optionNhomSanPham && optionNhomSanPham?.length > 0
                  ? option.ten
                  : "Tất cả"
              }
              placeholder="Chọn Nhóm sản phẩm"
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {options.ten}
                </Box>
              )}
              freeSolo
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          muiToolbarAlertBannerChipProps={{ color: "success" }}
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          enableRowNumbers
          rowNumberMode="static"
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              <Tooltip arrow placement="left" title="Chỉnh sửa">
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Xoá">
                <IconButton
                  color="primary"
                  onClick={() => {
                    let _data = [];
                    _data["id"] = row.getValue("id");
                    _data["ten"] = row.getValue("ten");
                    handleOpenDeleteConfirmation(_data);
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ color: "#ffffff" }}
                onClick={() => {
                  setAction("New");
                  setTitle("Thêm mới bộ tiêu chí");
                  setDataRow({});
                  setValidationErrors({});
                  setModalOpen(true);
                }}
              >
                Tạo mới
              </Button>
            </Stack>
          )}
          initialState={{
            expanded: true, //expand all groups by default
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              muiTableHeadCellProps: {
                align: "center",
              },
              muiTableBodyCellProps: {
                align: "center",
              },
              size: 80,
            },
          }}
          state={{
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            // sorting,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <CRUDBoTieuChi
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataNhom={optionBoWithNhom}
          dataNhomSanPham={optionNhomSanPham}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tên: {selectedRow?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BoTieuChi;
